"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getFromPalette = exports.getValueFromPath = exports.propValueFromCurrentTheme = void 0;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var getValueFromPath = function getValueFromPath(path, tokenTheme) {
  var designTokens = tokenTheme && tokenTheme.designTokens || {};

  var theme = _objectSpread({}, designTokens);

  var arrayPath = path.split("@theme:")[1].split(".");

  for (var index = 0; index < arrayPath.length; index++) {
    var element = theme[arrayPath[index]];

    if (element) {
      theme = element;
    } else return null;
  }

  return theme;
};

exports.getValueFromPath = getValueFromPath;

var getFromPalette = function getFromPalette(path, tokenTheme) {
  var palette = tokenTheme && tokenTheme.palette || {};
  var newPath = path;
  var withImportant = false;
  var position = newPath.indexOf("@palette:");
  var color = newPath.substring(position + 9).trim();

  if (color.endsWith("!important")) {
    newPath = newPath.replace("!important", "");
    withImportant = true;
    color = color.substring(0, color.length - 11).trim();
  }

  var result = palette && palette[color] || null;
  var evaluator = result && newPath.replace("@palette:".concat(color), result);
  return result && withImportant ? "".concat(evaluator, "!important") : evaluator;
};

exports.getFromPalette = getFromPalette;

var propValueFromCurrentTheme = function propValueFromCurrentTheme(props, tokenTheme) {
  var designTokens = tokenTheme && tokenTheme.designTokens || {};

  if (designTokens) {
    var newProps = {};
    Object.keys(props).map(function (prop) {
      if (props[prop] && typeof props[prop] === "string" && props[prop].toLowerCase().trim().startsWith("@theme:")) newProps[prop] = getValueFromPath(props[prop], {
        designTokens: designTokens
      });else newProps[prop] = props[prop];
      return prop;
    });
    return newProps;
  }

  return props;
};

exports.propValueFromCurrentTheme = propValueFromCurrentTheme;